module.exports = __webpack_public_path__ + "img/t4-i24.d6b24236.jpg";